import { theme } from '../theme';

export interface OnboardingItem {
  id: string;
  title: string;
  description: string;
  image?: string;
  video?: string;
  backgroundColor: string;
}

export const ONBOARDING_SLIDES: OnboardingItem[] = [
  {
    id: '1',
    title: 'Sales Made Simple',
    description:
      'Select items and quantity, select payment method, print and share receipts for fast checkouts.',
    image:
      'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782522/bizplus/onboarding/orderprocessing_gjiyxf_kfeoeq.png',
    backgroundColor: theme.colors.success,
  },
  {
    id: '2',
    title: 'Smart Inventory Management',
    description:
      'Track inventory and manage stock levels with real-time alerts when items run low. Never miss a sale again.',
    image:
      'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782523/bizplus/onboarding/smartinventory_ra51lz_cao769.png',
    backgroundColor: theme.colors.primary,
  },

  {
    id: '3',
    title: 'Sales and Cashflow Management',
    description:
      'Be on top of your cashflow distribution and volume for maximum business performance.',
    image:
      'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782518/bizplus/onboarding/analytics_b930gr_i4jgcw.png',
    backgroundColor: theme.colors.premiumDark,
  },
  {
    id: '4',
    title: 'Ready to Start?',
    description:
      'Join thousands of businesses already using BizPlus POS to boost profits.',
    image:
      'https://res.cloudinary.com/dbi34vmol/image/upload/v1771784950/bizplus/onboarding/Untitled_design_ozwzzv.png',
    backgroundColor: theme.colors.primaryDark,
  },
];

// Welcome screen: marquee wall images
export const WELCOME_WALL_IMAGES: string[] = [
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782622/bizplus/welcome/wmremove-transformed_1_nljtad.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1771783383/bizplus/welcome/result_0_qvbcpr.png',
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782622/bizplus/welcome/istockphoto-2220085621-1024x1024_nifpvw.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782621/bizplus/welcome/wmremove-transformed_sltvhg.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782621/bizplus/welcome/istockphoto-2232441345-1024x1024_c1pps3.jpg',
  'https://res.cloudinary.com/dbi34vmol/image/upload/v1771782620/bizplus/welcome/istockphoto-1157463906-1024x1024_md7cr6.jpg',
].filter(Boolean) as string[];
